import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { hot } from 'react-hot-loader/root'
import smoothscroll from 'smoothscroll-polyfill'
import Layout from './Layout'
import SidebarAndMap from './SidebarAndMap'
import PasswordSet from './PasswordSet/index'
import Form from './Form/FormDown'
import DownloadCSV from './DownloadCSV'
import AuxiliaryRoute from './AuxiliaryRoute'
import ProjectLoad from './ProjectLoad'

class App extends React.Component {
    componentDidMount() {
        smoothscroll.polyfill()
    }

    render() {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<SidebarAndMap />} />
                        <Route path="s/:hash/" element={<SidebarAndMap />} />
                        <Route
                            path="projects/:uuid/"
                            element={
                                <ProjectLoad>
                                    <SidebarAndMap />
                                </ProjectLoad>
                            }
                        />
                        <Route
                            path="download-csv/"
                            element={
                                <AuxiliaryRoute>
                                    <DownloadCSV />
                                </AuxiliaryRoute>
                            }
                        />
                        <Route path="submission-form/" element={<Form />} />
                        <Route
                            path="users/set-password/"
                            element={
                                <AuxiliaryRoute>
                                    <PasswordSet />
                                </AuxiliaryRoute>
                            }
                        />
                    </Route>
                </Routes>
            </BrowserRouter>
        )
    }
}

export default hot(connect()(App))
